import React from "react";
import SearchAndSelect from "../../../components/generic/search/SearchAndSelect";

const FormSummaryStatusSelect = ({ status, setStatus }) => {
  const options = [
    {
      label: "Approved",
      value: "Approved",
    },
    {
      label: "Pending Approval",
      value: "Submitted",
    },
    {
      label: "Rejected",
      value: "Rejected",
    },
  ];

  return (
    <>
      <div className="careplan-select-wrapper">
        <SearchAndSelect
          mode="multiple"
          selectedValues={status}
          placeholder="Click here to select status"
          setValue={setStatus}
          style={{
            width: "100%",
          }}
          options={options}
          selectOptionType="Simple"
          noDebounceSearch={true}
        />
      </div>
    </>
  );
};

export default FormSummaryStatusSelect;
